import { Flex, Spinner } from "@chakra-ui/react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { useUserAuth } from "./auth";

interface ProtectedRouteProps extends RouteProps {
  children: JSX.Element;
}

const ProtectedRoute = ({ children, ...rest }: ProtectedRouteProps) => {
  const { user, loading } = useUserAuth();

  const renderRoute = (props: any) => {
    // Attendre la restauration de la session avant de décider de rediriger
    if (loading) {
      return (
        <Flex minH="100vh" align="center" justify="center">
          <Spinner size="xl" />
        </Flex>
      );
    }
    if (!user) {
      // Mémorise la page demandée pour y revenir après connexion
      return (
        <Redirect
          to={{ pathname: "/auth/sign-in", state: { from: props.location } }}
        />
      );
    }
    return children;
  };
  return <Route {...rest} render={renderRoute} />;
};

export default ProtectedRoute;
